import { useMutation, useQueryClient } from 'react-query';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../../router/paths.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import toast from 'react-hot-toast';

type LogoutParams = { isManual: boolean };

async function logout({
  isManual
}: LogoutParams): Promise<'manual' | 'expired'> {
  try {
    await Axios.post(POST_URL().logout);
    return isManual ? 'manual' : 'expired';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    const status = error?.response?.status;

    if (status === 401) return 'expired';

    if (status >= 400 && status < 500) {
      toast.error(
        `Logout failed: ${error.response?.data?.error_description || 'Client error.'}`
      );
      return 'manual';
    }

    throw error;
  }
}

export function useLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<'manual' | 'expired', Error, LogoutParams>(logout, {
    onSuccess: async _result => {
      await queryClient.invalidateQueries(QueryKeys.login());
      TokenExtension.remove();
      // Clear remember_me preference on logout
      localStorage.removeItem('scriptix_remember_me');

      navigate(PATHS().LOGIN);
    },
    useErrorBoundary: false
  });
}
